<!-- eslint-disable max-len -->
<template>
  <div class="overflow-x-hidden">
    <!---rotate-2 -translate-x-2 width:101vw;-->
    <div
      class="z-10 absolute max-w max-h-96 w-full px-40 inset-0 bg-gradient-to-r from-cyan-400 to-blue-500 shadow-lg transform -skew-y-2"
      style="top:-10%; border-radius:0 0 10rem 0; overflow-y: hidden;"
    >
      <section class="transform rotate-2 -translate-x-36 md:-translate-x-20 translate-y-40">
        <h1 class="text-white font-bold text-5xl sm:text-5xl md:text-7xl">
          Welcome, {{ this.$store.state.account.user.displayName }}
        </h1>
      </section>
    </div>

    <section class="relative h-screen w-screen mt-60 md:mt-20 md:flex md:flex-wrap md:items-center">
      <div>
        <section id="Organisations" class="h-72 w-screen">
          <h3 class="text-4xl font-semibold text-gray-900 ml-5 mb-5 md:ml-20 z-40">
            Organisations
          </h3>
          <div
            class="w-scroll overflow-x-scroll overscroll-contain h-64 flex flex-row overflow-visible"
            style="width:calc(100vw - 1rem)"
          >
            <orgCard
              v-for="org in this.$store.state.organisations.data"
              :key="org.docID"
              :id="org.docID"
              :name="org.docData.name"
              :type="'org'"
              :location="
                org.docData.schoolLocations[0].street + ', ' + org.docData.schoolLocations[0].city
              "
            />
          </div>
        </section>
        <section id="Restaurants" class="h-60 min-w-full mt-20">
          <h3 class="text-4xl font-semibold text-gray-900 ml-5 mb-5 md:ml-20">Cards</h3>
          <div
            class="w-screen overscroll-contain overflow-x-scroll h-64 flex flex-row"
            style="width:calc(100vw - 1rem)"
          >
            <!--v-for="org in this.$store.state.organisations.data" :key="org.docID"-->
            <restCard />
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<style></style>

<script>
import orgCard from '@/components/Dashboard/Card_Organisation.vue';
import restCard from '@/components/Dashboard/Card_Restaurant.vue';

export default {
  components: {
    restCard,
    orgCard,
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.dispatch('fetchOrgs');
  },
};
</script>
